import React, { useDeferredValue } from 'react';
import { Collapse } from '@mui/material';
import { Control } from 'react-hook-form';
import CustomInputLabel from '../../../../../../layout/styledcomponents/CustomInputLabel';
import FormAutocomplete from '../../../../../shared/FormAutocomplete';
import FormSelect from '../../../../../shared/FormSelect';

type Option = { value: string; label: string };

export default function WorkspaceTypeAndMeetingRoom({
    control,
    availableSpaces,
    commercialHasExistingBooking,
    spaceType,
    meetingRoomsAvailable,
}: {
    control: Control<any>;
    availableSpaces: Option[];
    commercialHasExistingBooking: boolean;
    spaceType?: string;
    meetingRoomsAvailable: number;
}) {
    const deferredSpaceType = useDeferredValue(spaceType);

    return (
        <>
            <div>
                <CustomInputLabel
                    required={!deferredSpaceType}
                    htmlFor='space-type__input'
                >
                    Workspace Type
                </CustomInputLabel>
                <FormAutocomplete
                    id='space-type__input'
                    name='bookingInfo.spaceType'
                    control={control}
                    getOptionDisabled={(option: any) =>
                        Boolean(option?.disabled)
                    }
                    options={[
                        ...availableSpaces,
                        {
                            value: 'entireVenue',
                            label: `Entire Venue${
                                commercialHasExistingBooking
                                    ? ' (unavailable)'
                                    : ''
                            }`,
                        },
                    ]}
                />
            </div>
            <Collapse
                in={Boolean(
                    deferredSpaceType &&
                    deferredSpaceType !== 'meetingRoom' &&
                    deferredSpaceType !== 'entireVenue' &&
                    meetingRoomsAvailable > 0,
                )}
            >
                <CustomInputLabel
                    htmlFor='req-meeting-room__input'
                    id='req-meeting-room__label'
                >
                    Do you require a meeting room?
                </CustomInputLabel>
                <FormSelect
                    id='req-meeting-room__input'
                    labelId='req-meeting-room__label'
                    name='bookingInfo.reqMeetingRoom'
                    control={control}
                    defaultValue={false}
                    options={[
                        { value: true, label: 'Yes' },
                        { value: false, label: 'No' },
                    ]}
                />
            </Collapse>
        </>
    );
}
